import React, { Component, createContext, useContext } from 'react'
import { useOrganization } from 'contexts/organization'
import PubSub from 'pubsub-js'
import { v4 as uuid } from 'uuid'
import { get, post, remove } from 'api'

const WhistleblowingContext = createContext()
WhistleblowingContext.displayName = 'Whistleblowing'

class WhistleblowingProvider extends Component {
    constructor(props) {
        super(props)

        this.state = {
            configuration: null,
            settingUp: false,

            fetch: this.fetch,
            setSettingUp: settingUp => this.setState({ settingUp }),
            activate: this.activate,
            deactivate: this.deactivate
        }

        this.uuid = uuid()
        this.subscription = PubSub.subscribe('whistleblowing.refresh', (_, uuid) => {
            if(this.uuid !== uuid) {
                this.setState({ configuration: null }, this.fetch)
            }
        })
    }

    componentDidMount() {
        if(this.props.statuses?.hasSetUpWhistleblowing) {
            const {
                fetchAccess = true,
                fetchOnMount = true
            } = this.props

            if(fetchAccess && fetchOnMount) {
                this.fetch()
            }
        }
    }

    componentDidUpdate(props) {
        if(this.props?.statuses?.hasSetUpWhistleblowing) {
            const { fetchAccess: previousFetchAccess = true } = props

            const {
                fetchAccess = true,
                fetchOnMount = true
            } = this.props

            if(!previousFetchAccess && fetchAccess && fetchOnMount) {
                this.fetch()
            }
        }
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.subscription)
    }

    fetch = async () => {
        const { ok, response } = await get({ path: '/whistleblowing/config' })

        !!ok && this.setState({ configuration: response })

        return { ok, response }
    }

    activate = async () => {
        if(!!this.state.configuration?.active) {
            return {
                ok: true,
                response: this.state.configuration
            }
        }

        const { ok, response } = await post({ path: '/whistleblowing/config' })

        !!ok && this.setState({ configuration: response })

        return { ok, response }
    }

    deactivate = async () => {
        if(!this.state.configuration?.active) {
            return {
                ok: true,
                response: this.state.configuration
            }
        }

        const { ok, response } = await remove({ path: '/whistleblowing/config' })

        !!ok && this.setState({ configuration: response })

        return { ok, response }
    }

    render() {
        const { children = null } = this.props

        return (
            <WhistleblowingContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </WhistleblowingContext.Provider>
        )
    }
}

export const useWhistleblowing = () => useContext(WhistleblowingContext)

export default props => {
    const { statuses } = useOrganization()

    return (
        <WhistleblowingProvider
            {...props}
            statuses={statuses} />
    )
}